import React from "react";
import "./MenuTeams.css";
import { Button } from "@mui/material";
// import MenuListHeader from "../MenuListHeader/MenuListHeader";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

/**
 * A dropdown menu component for the header that displays a list of teams. It includes functionality to open and close the menu.
 * The menu is triggered by a button with a dropdown icon and is styled using Material-UI.
 * 
 * @component
 * @example
 * import MenuTeams from "../../Components/MenuTeams/MenuTeams";
 * <MenuTeams menuList={menuApi} />
 * @param {Array} menuList - A list of menu items (teams) to display in the dropdown. This data typically comes from an API.
 * @returns {React.Fragment} The rendered dropdown menu component.
 */
function MenuTeams({ menuList }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  /**
   * Handles the click event to open or close the dropdown menu.
   * 
   * @param {Event} event - The click event.
   */
  const onClickMenuHandler = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  // /**
  //  * Handles closing the dropdown menu.
  //  */
  // const onCloseMenuHandler = () => {
  //   setAnchorEl(null);
  // };

  // /**
  //  * Renders the list of menu items (teams) using the `MenuListHeader` component.
  //  *
  //  * @returns {Array} An array of `MenuListHeader` components.
  //  */
  // const displayOptions = () => {
  //   return [
  //     ...menuList.map((item) => (
  //       <MenuListHeader item={item} key={item.label} afterClick={onCloseMenuHandler} />
  //     ))
  //   ];
  // };

  return (
    <>    
      <Button
        id="menu-teams-button"
        aria-controls={open ? 'teams-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="text"
        disableElevation
        onClick={onClickMenuHandler}
        endIcon={<KeyboardArrowDownIcon />}
      >
        Teams
      </Button>
      {/* <Menu
        id="teams-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={onCloseMenuHandler}
        MenuListProps={{
          "aria-labelledby": "teams-button",
        }}
        sx={{ marginTop: "10px"}}
      >
        {displayOptions()}
      </Menu> */}
    </>
  );
}

export default MenuTeams;
